import { Button, Grid } from '@material-ui/core'
import { useState } from 'react'
import { StatusLote } from 'src/modules/lotes/types'
import { ConditionalTooltip } from './ConditionalTooltip'
import { returnStatusColor } from './Validation/StatusColors'
import ValidationConfirmDialog from './ValidationConfirmDialog'

type Props = {
  title: string
  message?: string
  status: StatusLote
  id: string
  isProgramacao?: boolean
  liberadaGestor?: boolean
  // Usado para travar o ATIVO enquanto faltam passos da integração da tabela de frete
  disabled?: boolean
  disabledReason?: string
}

export function ValidationRecord({
  title,
  status,
  id,
  liberadaGestor,
  disabled,
  disabledReason
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Grid item style={{ width: 160 }}>
        <ConditionalTooltip
          enabled={!!disabled && !!disabledReason}
          title={disabledReason ?? ''}
        >
          <Button
            fullWidth
            type="button"
            variant="outlined"
            disabled={disabled}
            onClick={() => setIsModalOpen(true)}
            style={{
              backgroundColor: returnStatusColor(title).color
            }}
          >
            {title}
          </Button>
        </ConditionalTooltip>
      </Grid>

      <ValidationConfirmDialog
        id={id}
        handleClose={() => setIsModalOpen(false)}
        liberadaGestor={liberadaGestor}
        open={isModalOpen}
        status={status}
      />
    </>
  )
}
